import { createContext } from 'react';

import { FeatureFlag } from '../flags';

export type UnleashFallbackFlags = Record<FeatureFlag, boolean>;

type UnleashFallbackContextType = {
  usingFallback: boolean;
  flags: UnleashFallbackFlags;
};

const buildDefaultFlags = (): UnleashFallbackFlags => {
  const defaults = {} as UnleashFallbackFlags;
  (Object.values(FeatureFlag) as FeatureFlag[]).forEach((flag) => {
    defaults[flag] = false;
  });
  return defaults;
};

export const UnleashFallbackContext = createContext<UnleashFallbackContextType>(
  {
    usingFallback: false,
    flags: buildDefaultFlags(),
  }
);
